import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";

import InfiniteCalendar, {
    Calendar,
    withRange,
} from 'react-infinite-calendar';

import 'react-infinite-calendar/styles.css';

class CambiaFecha extends Component {

    componentDidMount = () => {
        this.props.clear();
    }

    diaSelect = (rango) => {
        let dateOut = new Date(rango);
        let dayOut = dateOut.getDate();
        let monthOut = dateOut.getMonth() + 1;
        let yearOut = dateOut.getFullYear();

        if (dayOut < 10) dayOut = `0${dayOut}`
        if (monthOut < 10) monthOut = `0${monthOut}`
        
        let diaOutF = `${dayOut}/${monthOut}/${yearOut}`;

        document.getElementById("fechaInCitaI").value = diaOutF;
        this.props.fechaO(diaOutF)
    }

    render (){
        let {fechaI} = this.props;
        let dateParts = fechaI.split("/");
        let dateOut = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);

        return (
            <React.Fragment>
                <InfiniteCalendar
                    displayOptions={{ layout: 'landscape' }}
                    width="100%"
                    height={220}
                    min={dateOut}
                    minDate={dateOut}
                    selected={dateOut}
                    locale={{
                        locale: require('date-fns/locale/es'),
                        headerFormat: 'D MMM',
                        weekdays: ["Dom", "Lun", "Mar", "Mier", "Jue", "Vie", "Sab"],
                        todayLabel: {
                            long: 'Hoy',
                            short: 'Hoy'
                        }
                    }}
                    onSelect={(date) => { this.diaSelect(date) }}

                    theme={{
                        selectionColor: '257777',
                        textColor: {
                            default: '#333',
                            active: '#FFF'
                        },
                        weekdayColor: '257777',
                        todayColor: '257777',
                        headerColor: '1f2f6e',
                        floatingNav: {
                            background: 'rgba(160, 85, 92, 0.96)',
                            color: '#FFF',
                            chevron: 'rgba(255, 255, 255, 0)'
                        }
                    }}
                />
                <Row>
                    <Col md = {6} className="custom-mt-10">
                        <input type ="text" className="form-control" disabled = {true}  value = {fechaI}/>
                        <div className="text-danger" style={{fontSize: 10}}>Fecha Original</div>
                    </Col>
                    <Col md = {6} className="custom-mt-10">
                        <input type ="text" className="form-control" disabled = {true} id = "fechaInCitaI"/>
                        <div className="text-danger" style={{fontSize: 10}}>Nueva Fecha</div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

 
export default CambiaFecha;


// WEBPACK FOOTER //
// ./src/views/AdmisionAdmin/AdmisionAdminContent/CambiaFecha.jsx